import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import NewModelFormFields from './NewModelFormFields';


const NewModelForm = ({
  initialValues,
  onSubmit,
  showFileInput = true,
  handleCloseModal,
  FieldsComponent = NewModelFormFields,
  requireZooSelection = true,
}) => {
  const [modelInfoForm, setModelInfoForm] = useState(initialValues);

  // STAGED ZOO state lifted here — defaulting to public until UI is re-enabled
  // change true to false again when enabling again the public/private selection in the UI
  const [selectedZoo, setSelectedZoo] = useState({
    public: initialValues.in_model_zoo_public || true,
    private: initialValues.in_model_zoo_private || false,
  });

  const handleChange = (e) => {
    const { name, type, value } = e.target;
    
    let finalValue;
    if (type === "file") {
      finalValue = e.target.files[0];
    } else if (type === "file-multi") {
      finalValue = value; // already an array of files from onChange above
    } else {
      finalValue = value;
    }

    const keys = name.split(".");
    setModelInfoForm((prev) => {
      const updated = { ...prev };
      let nested = updated;
      for (let i = 0; i < keys.length - 1; i++) {
        nested[keys[i]] = { ...nested[keys[i]] };
        nested = nested[keys[i]];
      }
      nested[keys[keys.length - 1]] = finalValue;
      return updated;
    });
  };

  const handleSubmit = async () => {
    if (
      requireZooSelection &&
      !selectedZoo.public &&
      !selectedZoo.private &&
      !modelInfoForm.in_model_zoo_public &&
      !modelInfoForm.in_model_zoo_private
    ) {
      alert('Please select at least one: Public or Private.');
      return;
    }

    const updatedForm = {
      ...modelInfoForm,
      in_model_zoo_public: modelInfoForm.in_model_zoo_public || selectedZoo.public,
      in_model_zoo_private: modelInfoForm.in_model_zoo_private || selectedZoo.private,
    };

    await onSubmit(updatedForm);

    // Update local state if necessary
    setModelInfoForm(updatedForm);
  };


  return (
    <>
      {/* <NewModelFormFields form={modelInfoForm} handleChange={handleChange} width="95%" /> */}
      <FieldsComponent
        form={modelInfoForm}
        handleChange={handleChange}
        showFileInput={showFileInput}
        width="95%"
        selectedZoo={selectedZoo} // pass staged state
        setSelectedZoo={setSelectedZoo}
      />

      <Box sx={{ padding: 2, width: '50%', mx: 'auto', mt: 1, display: 'flex', justifyContent: 'center', gap: 4 }}>
        <Button
          variant="outlined"
          onClick={handleCloseModal}
          sx={{ borderRadius: '12px', textTransform: 'none', fontSize: '16px', width: '120px', color: '#16a4b0', borderColor: '#16a4b0', '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#16a4b0' } }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ borderRadius: '12px', backgroundColor: '#16a4b0', color: 'white', textTransform: 'none', fontSize: '16px', width: '120px', '&:hover': { backgroundColor: '#00707c' } }}
        >
          Import
        </Button>
      </Box>
    </>
  );
};
 
export default NewModelForm;
